import { render, staticRenderFns } from "./MSPointStakingSetting.vue?vue&type=template&id=3127e314&"
import script from "./MSPointStakingSetting.vue?vue&type=script&lang=js&"
export * from "./MSPointStakingSetting.vue?vue&type=script&lang=js&"
import style0 from "./MSPointStakingSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports